export function mondayOf(date = new Date()) {
  const d = new Date(date);
  d.setHours(12, 0, 0, 0);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  return d;
}

export function formatIsoDate(date) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function shiftWeek(isoMonday, delta) {
  const d = new Date(`${isoMonday}T12:00:00`);
  d.setDate(d.getDate() + delta * 7);
  return formatIsoDate(d);
}

export function formatDayLabel(value) {
  if (!value) return '';
  const raw = String(value);
  const date = raw.length <= 10 ? new Date(`${raw.slice(0, 10)}T12:00:00`) : new Date(raw);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
}

export function formatWeekLabel(isoMonday) {
  const start = new Date(`${isoMonday}T12:00:00`);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const fmt = (d) => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  return `${fmt(start)} – ${fmt(end)}`;
}

export function weekOffsetCaption(isoMonday) {
  const current = formatIsoDate(mondayOf());
  if (isoMonday === current) return 'Cette semaine';
  if (isoMonday === shiftWeek(current, 1)) return 'Semaine prochaine';
  if (isoMonday === shiftWeek(current, -1)) return 'Semaine dernière';
  const start = new Date(`${current}T12:00:00`).getTime();
  const target = new Date(`${isoMonday}T12:00:00`).getTime();
  const diff = Math.round((target - start) / (7 * 24 * 60 * 60 * 1000));
  return `Semaine ${diff > 0 ? '+' : ''}${diff}`;
}

export function formatMinutes(minutes) {
  const value = Number(minutes) || 0;
  const hours = Math.floor(value / 60);
  const mins = value % 60;
  if (hours <= 0) return `${mins} min`;
  if (mins === 0) return `${hours} h`;
  return `${hours} h ${mins}`;
}
